import React, { useEffect } from "react";
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
  RichTextEditor,
  MenuButtonUnderline,
  MenuButtonOrderedList,
  MenuButtonImageUpload,
  MenuButtonUndo,
  MenuButtonRedo,
  MenuButtonHorizontalRule,
  MenuButtonBulletedList,
  MenuButtonEditLink,
} from "mui-tiptap";
import StarterKit from "@tiptap/starter-kit";
import TextStyle from "@tiptap/extension-text-style";
import Underline from "@tiptap/extension-underline";
import Image from "@tiptap/extension-image";
import BulletList from "@tiptap/extension-bullet-list";
import ListItem from "@tiptap/extension-list-item";
import Link from "@tiptap/extension-link";
import {
  createContentImageInContainer,
} from "src/utils/azureBlob";

const RichTextEditorDialog = ({ editorRef, value, onChange, fieldName }) => {
  useEffect(() => {
    if (editorRef && editorRef.current && editorRef.current.editor) {
      const currentHTML = editorRef.current.editor.getHTML();
      if (currentHTML !== value) {
        editorRef.current.editor.commands.setContent(value || "");
      }
    }
  }, [value, editorRef]);

  const handleAddImage = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";

    input.onchange = async (event) => {
      const file = event.target.files?.[0];
      if (!file) return;

      const fileExtension = file.name.split(".").pop();
      const uniqueFilename = `${Date.now()}.${fileExtension}`;

      try {
        // Upload to Azure (or your storage method)
        await createContentImageInContainer(file, uniqueFilename);

        const containerName =
          process.env.REACT_APP_CONTENTIMAGES_STORAGE_CONTAINER;
        const storageAccountName =
          process.env.REACT_APP_CONTENTIMAGES_STORAGERESOURCENAME;
        const imageUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${uniqueFilename}`;

        // Insert image into the editor
        if (editorRef.current?.editor) {
          editorRef.current.editor
            .chain()
            .focus()
            .setImage({ src: imageUrl })
            .run();
        }
      } catch (error) {
        console.error("Image upload failed:", error);
      }
    };

    input.click();
  };

  return (
    <RichTextEditor
      ref={editorRef}
      content={value}
      onUpdate={({ editor }) => {
        const html = editor.getHTML();
        onChange(html);
      }}
      extensions={[
        StarterKit,
        TextStyle,
        Underline,
        BulletList,
        ListItem,
        Link.configure({
          openOnClick: true,
          autolink: true,
        }),
        Image.configure({
          inline: true,
        }),
      ]}
      renderControls={() => (
        <MenuControlsContainer>
          <MenuSelectHeading />
          <MenuDivider />
          <MenuButtonBold />
          <MenuButtonItalic />
          <MenuButtonUnderline />
          <MenuButtonOrderedList />
          <MenuButtonBulletedList />
          <MenuButtonUndo />
          <MenuButtonRedo />
          <MenuButtonHorizontalRule />
          <MenuDivider />
          <MenuButtonEditLink
            onClick={() => {
              const url = prompt("Enter the URL:");
              if (url) {
                editorRef.current.editor
                  .chain()
                  .focus()
                  .setLink({ href: url })
                  .run();
              }
            }}
          />
          <MenuButtonImageUpload
            onClick={handleAddImage}
            variant="outlined"
            size="small"
            sx={{ ml: 1 }}
          />
        </MenuControlsContainer>
      )}
    />
  );
};

export default RichTextEditorDialog;
